import { atom } from 'jotai';

export type Sidebar =
  | 'SectionsPane'
  | 'ActionsPanel'
  | 'ProjectSidebar'
  | 'TemplatesSidebar'
  | 'Notifications';

export const sidebarState = atom<Sidebar | null>(null);
